// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__2BMJS","containerItemsCenter":"Skeleton_containerItemsCenter__27Yjk"};